import React from 'react';
import Spinner from './Spinner';
import './ModalLoading.css';

const ModalLoading = ({ text = 'Loading...' }) => (
  <div className="modal-loading" role="status" aria-live="polite">
    <div className="modal-loading-group">
      <Spinner />
      <div className="loading-text">{text}</div>
    </div>
  </div>
);

export default ModalLoading;
